import { InjectionToken, Provider } from '@angular/core'

export const appNameToken = new InjectionToken<string>('AppNameToken')

export const appNameProvider: Provider = [
  {
    provide: appNameToken,
    useValue: $localize`:App name:Game Sans`,
  },
]
